export const INIT_SETTINGS = 'INIT_SETTINGS';
export const SET_LOADER = 'SET_LOADER';
export const SUBMITTED = 'SUBMITTED';
export const SET_HAMBURGER = 'SET_HAMBURGER';
